import * as models from "app/models/requireme";
import { orderBy, pick } from "keautils";

export interface PuntoRuta {
    IdSegmento: number;
    NombreSegmento: string;
    IdSucursalOrigen: number;
    IdSucursalDestino: number;
}

export type PuntosRuta = PuntoRuta[];

/**Mapea un conjunto de RutaSucursal a un PuntosRuta */
export function map(x: models.RutaSucursalDTO[]): PuntosRuta {
    return  orderBy(x, x => x.Orden).map(x => pick(x, "IdSegmento",   "NombreSegmento", "IdSucursalOrigen", "IdSucursalDestino"));
}

/**Mapea un PuntosRuta a un arreglo de RutaSucursal */
export function unmap(x: PuntosRuta) : models.RutaSucursalDTO[] {
    return x.map((x,i) => ({
        ... x,
        Orden: i,
    } as models.RutaSucursalDTO))
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/rutas/edit/puntos/logic.tsx